import { PurcharseDetail, PurcharseReponse } from './../../../shared/interfaces/mechanic/invoice-detail';
import { InvoiceUpdateResponse } from './../../../shared/interfaces/mechanic/ocr-model';
import { AdminProduct, InvoiceReponse } from './../interface/base';
import { BaseModel } from '../interface/base';
import { Injectable } from '@angular/core';
import { Observable, config } from 'rxjs';
import { Campaign } from '../interface/campaign';
import { ApiService } from 'app/shared/services/api.service';
import { Config, chilPath, menuHome } from 'app/config/config';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ListPurchaseService {

  constructor(
    private apiService: ApiService
  ) { }

  public getProduct (): Observable<AdminProduct[]>{
    return this.apiService.get <AdminProduct[]>(`${Config.unileverApiPath.adminProduct}`, environment.unileverApiHost);
  }

  public createInvoice(data:any)
  {
    return this.apiService.post<InvoiceUpdateResponse>(`${Config.unileverApiPath.createInvoice}`,data, environment.unileverApiHost);
  }

  public getInvoiceDetail(invoiceId: string): Observable<PurcharseReponse>
  {
    return this.apiService.get<PurcharseReponse>(`${Config.unileverApiPath.getInvoiceDetail}?invoiceId=${invoiceId}`);
  }

}
